import useStyles from "../../styles";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  FormLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { fetchExamDate, fetchExamByDate } from "../../service/services";
import { toast, ToastContainer } from "react-toastify";

function ReportHeaderNotPreview({ exportApi, setLoaderOpen, type = null, secondDate, reportName = "Report", fileName = null, examType = "main" }) {
  const classes = useStyles();
  const navigate = useNavigate();
  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  const [examDate, setExamDate] = useState([]);
  const [selectedExamDate, setSelectedExamDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [exam, setExam] = useState([]);
  const [selectedExam, setSelectedExam] = useState("");

  const [fileURL, setFileURL] = useState("");

  const handleExamDateChange = (event) => {
    setSelectedExamDate(event.target.value);
    setSelectedExam("");
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value);
  };

  const handleExamChange = (event, newValue) => {
    setSelectedExam(newValue ? newValue.id : event?.target?.value || "");
  };

  const fetchExamDateAPi = async () => {
    try {
      const response = await fetchExamDate();
      setExamDate(response.exams);
    } catch (error) {
      console.log("Error fetching question paper:", error);
    }
  };

  useEffect(() => {
    fetchExamDateAPi();
  }, []);

  const fetchExamAPi = async () => {
    try {
      const response = await fetchExamByDate(selectedExamDate, examType);
      if (response.success) {
        if (type === "section") {
          const data = response.exams.filter(
            (exam) => exam.exam_template !== "default"
          );
          setExam(data);
        } else {
          setExam(response.exams);
        }
      }
    } catch (error) {
      console.log("Error fetching question paper:", error);
    }
  };

  useEffect(() => {
    if (selectedExamDate) {
      fetchExamAPi(selectedExamDate);
    }
  }, [selectedExamDate]);

  // const handleExportClick = async () => {
  //   console.log("selectedExam", selectedExam);
  //   try {
  //     if (!selectedExam) {
  //       toast.error("Export file is not available for this.");
  //       return;
  //     }

  //     setLoaderOpen(true); // show loader before API call

  //     // ✅ use exportApi instead of Report2Api
  //     const response = await exportApi(selectedExam);

  //     if (response.success === false) {
  //       setLoaderOpen(false);
  //       toast.warning(response.message || "Failed to download the CSV file.");
  //       return;
  //     }

  //     if (response.success) {
  //       setFileURL(response.file_url);
  //       window.open(response.file_url, "_blank");
  //       toast.success("CSV has been downloaded successfully.");
  //       setLoaderOpen(false);
  //     }
  //   } catch (error) {
  //     console.error("API Error:", error);
  //     const errorMessage =
  //       error.response?.data?.message ||
  //       "An error occurred while fetching the data.";
  //     toast.error(errorMessage);
  //     setLoaderOpen(false);
  //   }
  // };


  // const handleExportClick = async () => {
  //   try {
  //     if (!selectedExam) {
  //       toast.error("Export file is not available for this.");
  //       return;
  //     }

  //     setLoaderOpen(true);

  //     const response = await exportApi(selectedExam);

  //     if (response) {
  //       const blob = new Blob([response], { type: "text/csv" });
  //       const url = window.URL.createObjectURL(blob);

  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.download = `${fileName}.csv`;
  //       document.body.appendChild(link);
  //       link.click();

  //       link.remove();
  //       window.URL.revokeObjectURL(url);

  //       toast.success("CSV has been downloaded successfully.");
  //     } else {
  //       toast.error("Failed to download the CSV file.");
  //     }
  //   } catch (error) {
  //     console.error("API Error:", error);

  //     const errorMessage =
  //       error.response?.data?.message ||
  //       "An error occurred while fetching the data.";

  //     toast.error(errorMessage);
  // };

  const getErrorMessage = async (res) => {
    if (!res) return null;
    if (res.success === false) return res.message;
    if (res.data?.success === false) return res.data.message;
    if (res.data instanceof Blob) {
      try {
        const text = await res.data.text();
        if (text.trim().startsWith("{")) {
          const parsed = JSON.parse(text);
          if (parsed?.success === false || parsed?.message) {
            return parsed.message || "An error occurred during the API request.";
          }
        }
      } catch (e) { }
    }
    return null;
  };

  const handleExportClick = async () => {
    try {
      if (secondDate) {
        // Date-wise report flow
        if (!selectedExamDate) {
          toast.error("Please select From date.");
          return;
        }
        if (!toDate) {
          toast.error("Please select To date.");
          return;
        }

        setLoaderOpen(true);
        const response = await exportApi(selectedExamDate, toDate);

        const errorMsg = await getErrorMessage(response);
        if (errorMsg) {
          toast.error(errorMsg);
          setLoaderOpen(false);
          return;
        }

        // if (response.success === false) {
        //   setLoaderOpen(false);
        //   toast.warning(response.message || "Failed to download the report.");
        //   return;
        // }

        // API returns CSV blob — download as .xlsx


        // if (response.data.success) {
        //   const fileUrl = response.data.file_url;
        // 
        //   const link = document.createElement("a");
        //   link.href = fileUrl;
        //   link.download = "export.csv";
        //   document.body.appendChild(link);
        //   link.click();
        //   link.remove();
        //   setLoaderOpen(false);
        // }

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${reportName}_${selectedExamDate}_to_${toDate}.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        toast.success("Report has been downloaded successfully.");
        setLoaderOpen(false);
      } else {
        // Existing exam-based flow
        console.log("selectedExam", selectedExam);
        if (!selectedExam) {
          toast.error("Export file is not available for this.");
          return;
        }

        setLoaderOpen(true);

        let apiParam = selectedExam;
        if (reportName === "CenterFeedbackReport") {
          const selectedExamObj = exam.find((e) => String(e.id) === String(selectedExam));
          if (selectedExamObj && selectedExamObj.demo_exam_id) {
            apiParam = selectedExamObj.demo_exam_id;
          }
        }
        const response = await exportApi(apiParam);

        const errorMsg = await getErrorMessage(response);
        if (errorMsg) {
          toast.error(errorMsg);
          setLoaderOpen(false);
          return;
        }

        const selectedExamObj = exam.find((e) => String(e.id) === String(selectedExam));
        const examNameOnly = selectedExamObj
          ? (selectedExamObj.exam_name || "").trim().replace(/[/\\?%*:|"<>]/g, "_").replace(/\s+/g, "_")
          : "";

        const isDirectExamNameReport =
          // reportName === "ConsolidatedCBT_Report" ||
          // reportName === "ConsolidatedIBT_Report" ||
          // reportName === "FacultyFeedbackReport" ||
          fileName === "ConsolidatedCBT_Report" ||
          fileName === "ConsolidatedIBT_Report" ||
          fileName === "FacultyFeedbackReport" ||
          fileName === "VerticalResponseReportCBT_Report" ||
          fileName === "VerticalResponseReportIBT_Report";

        // if (response.data && response.data.success && response.data.file_url) {
        //   const fileUrl = response.data.file_url;
        // 
        //   const link = document.createElement("a");
        //   link.href = fileUrl;
        //   const downloadName = isDirectExamNameReport && examNameOnly ? `${examNameOnly}.csv` : `${fileName}.csv`;
        //   link.download = downloadName;
        //   document.body.appendChild(link);
        //   link.click();
        //   link.remove();
        //   setLoaderOpen(false);
        // } else 
        if (response.data) {
          const responseData = response.data;
          const headers = response.headers || {};
          const contentType = headers["content-type"] || (responseData instanceof Blob ? responseData.type : "");

          let extension = "csv";
          if (contentType.includes("spreadsheetml") || contentType.includes("excel")) {
            extension = "xlsx";
          } else if (
            contentType.includes("zip") ||
            reportName === "ConsolidatedCBT_Report" ||
            reportName === "ConsolidatedIBT_Report" ||
            fileName === "ConsolidatedCBT_Report" ||
            fileName === "ConsolidatedIBT_Report"
          ) {
            extension = "zip";
          } else if (contentType.includes("pdf")) {
            extension = "pdf";
          }

          const blob = responseData instanceof Blob
            ? responseData
            : new Blob([responseData], { type: contentType || "application/octet-stream" });

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          const downloadName = isDirectExamNameReport && examNameOnly
            ? `${examNameOnly}.${extension}`
            : `${fileName}.${extension}`;
          link.setAttribute("download", downloadName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          toast.success(`${extension.toUpperCase()} downloaded successfully.`);
          setLoaderOpen(false);
        }
        //   if (response) {
        // // Service level success check
        //     if (response.success === false) {
        //       setLoaderOpen(false);
        //     toast.warning(response.message || "Failed to download the CSV file.");
        //       return;
        //     }

        // // Extract data and content type
        //     const responseData = response.data !== undefined ? response.data : response;
        //     const headers = response.headers || {};
        //     const contentType = headers["content-type"] || (responseData instanceof Blob ? responseData.type : "");

        //     let extension = "csv";
        //     if (contentType.includes("spreadsheetml") || contentType.includes("excel")) {
        //       extension = "xlsx";
        //     } else if (contentType.includes("zip")) {
        //       extension = "zip";
        //     } else if (contentType.includes("pdf")) {
        //       extension = "pdf";
        //     } else if (contentType.includes("text/csv")) {
        //       extension = "csv";
        //     }

        // // Convert to blob if it's not already one
        //     const blob = responseData instanceof Blob ? responseData : new Blob([responseData], { type: contentType || "text/csv;charset=utf-8;" });

        //     const url = window.URL.createObjectURL(blob);

        //     const link = document.createElement("a");
        //     link.href = url;
        // link.download = `${reportName || "Report"}.${extension}`;

        //     document.body.appendChild(link);
        //     link.click();

        //     document.body.removeChild(link);
        //     window.URL.revokeObjectURL(url);

        //     toast.success(`${extension.toUpperCase()} downloaded successfully.`);
        //     setLoaderOpen(false);
        //   } else {
        //     toast.error("Failed to download the file.");
        //     setLoaderOpen(false);
        //   }
      }
    } catch (error) {
      console.error("API Error:", error);
      let errorMessage = "An error occurred while fetching the data.";
      if (error.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const parsed = JSON.parse(text);
          if (parsed?.message) {
            errorMessage = parsed.message;
          }
        } catch (e) {}
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }
      toast.error(errorMessage);
      setLoaderOpen(false);
    }
  };

  return (
    <>
      <div
        className={` ${classes.w80} ${classes.border1999} ${classes.bgwhite} ${classes.m0auto} ${classes.mt1} ${classes.borderradius6px} ${classes.inputpadding} ${classes.dflex} ${classes.flexdirectioncolumn}`}
      >
        {/* ✅ Grey Header */}
        <div
          style={{
            backgroundColor: "#f5f5f5", // light grey
            padding: "10px 16px",
            borderTopLeftRadius: "6px",
            borderTopRightRadius: "6px",
            borderBottom: "1px solid #ddd",
          }}
        >
          <h3
            style={{
              margin: 0,
              fontSize: "16px",
              fontWeight: 600,
              color: "#333",
              fontFamily: "Outfit, sans-serif",
            }}
          >
            Report Option
          </h3>
        </div>

        {/* ✅ Body Content */}
        <div
          className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.alignitemscenter} ${classes.w100}`}
        >
          {/* Exam Date */}
          <div
            className={`${classes.dflex} ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.mt1} ${classes.w90}`}
          >
            {!secondDate
              &&
              (<FormLabel
                className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.mb0_5} ${classes.fontsize1}`}
              >
                Exam Date
              </FormLabel>)}

            {secondDate && (<FormLabel
              className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.mb0_5} ${classes.fontsize1}`}
            >
              From
            </FormLabel>
            )}
            {/* <Select
              id="examdate"
              value={selectedExamDate}
              onChange={handleExamDateChange}
              displayEmpty
              className={classes.selectEmpty}
              MenuProps={menuProps}
              variant="outlined"
            >
              <MenuItem disabled value="">
                <em className={classes.defaultselect}>Select Date</em>
              </MenuItem>
              {examDate?.map((st) => (
                <MenuItem key={st.start_date} value={st.start_date}>
                  {st?.start_date}
                </MenuItem>
              ))}
            </Select> */}
            <TextField
              type="date"
              variant="outlined"
              required
              value={selectedExamDate}
              onChange={handleExamDateChange}
              placeholder="Select Date"
            />
          </div>

          {/* Exam Selection */}
          {!secondDate && (<div
            className={`${classes.dflex} ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.mt1} ${classes.w90}`}
          >
            <FormLabel
              className={`${classes.textcolorformlabel} ${classes.mb0_5} ${classes.fontfamilyoutfit} ${classes.fontsize1}`}
            >
              Exam
            </FormLabel>
            {/* <Select
              id="exam"
              value={selectedExam}
              onChange={handleExamChange}
              displayEmpty
              MenuProps={menuProps}
              variant="outlined"
            >
              <MenuItem disabled value="">
                <em className={classes.defaultselect}>Select Exam</em>
              </MenuItem>
              {exam?.map((data, index) => (
                <MenuItem value={data.id} key={index}>
                  {data.exam_code} -  {data.exam_name}
                </MenuItem>
              ))}
            </Select> */}

            <Autocomplete
              id="exam-autocomplete"
              options={exam || []}
              getOptionLabel={(option) =>
                option?.exam_code
                  ? `${option?.exam_code} - ${option?.exam_name}`
                  : option?.exam_name || ""
              }
              getOptionSelected={(option, value) => option?.id === value?.id}
              value={exam?.find((data) => data.id === selectedExam) || null}
              onChange={handleExamChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Exam"
                  variant="outlined"
                />
              )}
            />
          </div>
          )}

          {secondDate && (
            <div
              className={`${classes.dflex} ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.mt1} ${classes.w90}`}
            >
              <FormLabel
                className={`${classes.textcolorformlabel} ${classes.mb0_5} ${classes.fontfamilyoutfit} ${classes.fontsize1}`}
              >
                To
              </FormLabel>
              <TextField
                type="date"
                variant="outlined"
                required
                value={toDate}
                onChange={handleToDateChange}
                placeholder="Select Date"
              />
            </div>
          )}
          <div
            className={`${classes.dflex} ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.mt1} ${classes.mb1} ${classes.w90}`}
          >
            {" "}
            <Button
              variant="contained"
              color="primary"
              className={`${classes.bluebtn} ${classes.alignSelfEnd}`}
              onClick={handleExportClick}
            >
              Run Report
            </Button>
          </div>
          {/* Run Report Button */}
        </div>
      </div>
      <ToastContainer />
    </>
  );
}
export default ReportHeaderNotPreview;
